import CreateBillingUser from "./CreateBillingUser";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function CreateBillingUserWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <CreateBillingUser />
        </XeroFeatureFlagCheck>
    )
}

export default CreateBillingUserWrapper;